import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AbstractService } from 'src/app/service/api/abstract.service';
import { LoginService } from 'src/app/service/api/login.service';

@Injectable({
  providedIn: 'root',
})
export class EncryptService extends AbstractService {
  constructor(protected override http: HttpClient, private loginService: LoginService) {
    super(http);
  }

  private key: CryptoJS.lib.WordArray;
  private iv: CryptoJS.lib.WordArray;

  getHashInfo() {
    this.loginService.getHashInfo().subscribe((data) => {
      this.key = CryptoJS.enc.Utf8.parse(data.key);
      this.iv = CryptoJS.enc.Utf8.parse(data.iv);
    });
  }

  encryptUsingAES256(text: string) {
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(text),
      this.key,
      {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  }

  decryptUsingAES256(decString: string) {
    const decrypted = CryptoJS.AES.decrypt(decString, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
